(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue-status', {
            parent: 'entity',
            url: '/queue-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-status/queue-statuses.html',
                    controller: 'QueueStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-status-detail', {
            parent: 'entity',
            url: '/queue-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queueStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-status/queue-status-detail.html',
                    controller: 'QueueStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queueStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'QueueStatus', function($stateParams, QueueStatus) {
                    return QueueStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-status-detail.edit', {
            parent: 'queue-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-status/queue-status-dialog.html',
                    controller: 'QueueStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueStatus', function(QueueStatus) {
                            return QueueStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-status.new', {
            parent: 'queue-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-status/queue-status-dialog.html',
                    controller: 'QueueStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue-status', null, { reload: 'queue-status' });
                }, function() {
                    $state.go('queue-status');
                });
            }]
        })
        .state('queue-status.edit', {
            parent: 'queue-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-status/queue-status-dialog.html',
                    controller: 'QueueStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QueueStatus', function(QueueStatus) {
                            return QueueStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-status', null, { reload: 'queue-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-status.delete', {
            parent: 'queue-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-status/queue-status-delete-dialog.html',
                    controller: 'QueueStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['QueueStatus', function(QueueStatus) {
                            return QueueStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-status', null, { reload: 'queue-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
